import React from 'react';
import { motion } from 'framer-motion';
import ProductCard from '../components/ui/ProductCard';
import { products } from '../data/storeData';

export default function Shop() {
  return (
    <motion.div 
      initial={{ opacity: 0 }} 
      animate={{ opacity: 1 }} 
      className="min-h-screen bg-cream py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="font-serif text-4xl md:text-5xl text-navy mb-4">All Goods</h1>
          <div className="w-16 h-1 bg-saddle mx-auto mb-6"></div>
          <p className="font-sans text-navy/70 max-w-2xl mx-auto">
            Every piece is crafted by hand in our workshop using full-grain leather and solid brass hardware. Browse our complete collection of bags, wallets, and accessories.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 gap-y-12">
          {products.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </motion.div>
  );
}